<template>
  <KeypadSetting
    :tag
    :prefix
    :reference
    :popoverTitle
    :popoverPrefix
    :popoverReference
    :selectedCells
    :applyToAllColumnsEnabled
    :getSubmitValues
    v-model:showingPopover="showingPopover"
    v-model:applyToAllBins="applyToAllBins"
  >
    <slot>
      <span v-if="disabled">
        {{ cellCaptionWhenDisabled }}
      </span>
    </slot>
    <template #HelpText="{helpText}">
      <slot name="HelpText">
        <div class="helpText" v-html="helpText"></div>
      </slot>
    </template>
    <template #Buttons>
      <slot name="Buttons"></slot>
      <Button v-if="!disabled" severity="secondary" @click="disable()" style="align-self: stretch;">
        {{ disableButtonCaption }}
      </Button>
    </template>
    <template #BinSelectionInput>
      <slot name="BinSelectionInput"></slot>
    </template>
  </KeypadSetting>

</template>

<script setup>
import { computed } from "vue";
import KeypadSetting from "./KeypadSetting.vue";
import { changeSettings } from "./appUtility";

let props = defineProps([
  "tag",
  "prefix",
  "reference",
  "showingPopover",
  "popoverTitle",
  "popoverPrefix",
  "popoverReference",
  "disableInvertKey",
  "toggleTag",
  "toggleStateWhenDisabled",
  "cellCaptionWhenDisabled",
  "keypadTitleWhenDisabled",
  "keypadTitleWhenEnabled",
  "disableButtonCaption",
  "selectedCells",
  "getDisableSubmitValues",
  "applyToAllBins",
  "applyToAllColumnsEnabled",
]);

let applyToAllBins = defineModel("applyToAllBins");
let showingPopover = defineModel("showingPopover");

let disabled = computed(() => {
  let toggleTag = props.tag[props.toggleTag];
  return toggleTag.value == props.toggleStateWhenDisabled;
});

function getSubmitValues(cell, value) {
  return [{
    handle: cell.componentArgs.tag.handle,
    value: {
      value,                                              // keypad value
      [props.toggleTag]: !props.toggleStateWhenDisabled   // toggle value
    }
  }];
}

function getDisableSubmitValues(cell) {
  if (props.getDisableSubmitValues)
    return props.getDisableSubmitValues();
  else
    return [{
      handle: cell.componentArgs.tag.handle,
      value: {
        [props.toggleTag]: props.toggleStateWhenDisabled
      }
    }];
}

function disable() {
  showingPopover.value = false;
  changeSettings(props.selectedCells, getDisableSubmitValues);
}
</script>